import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMobileMenu = styled.div`
  display: none;
  position: fixed;
  bottom: 0;
  z-index: 1010;
  width: 100vw;
  height: 100px;
  background-color: ${({ theme }) => theme.white};
  border-radius: 15px 15px 0 0;

  .mobile-menu-container {
    display: none;
    box-shadow: 0px 4px 84px 0px ${({ theme }) => theme.boxShadowColor};

    border-radius: 15px 15px 0 0;

    :where(.ant-btn).ant-btn-variant-text:not(:disabled):not(
        .ant-btn-disabled
      ):hover {
      background-color: transparent;
    }
  }

  .mobile-menu-item {
    position: relative;

    .mobile-menu-cart-total {
      position: absolute;
      background-color: ${({ theme }) => theme.brand02};
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 10px;
      padding: 2px 6px 2px 7px;
      font-size: 12px;
      color: ${({ theme }) => theme.white};
      font-family: ${({ theme }) => theme.fontText};
      font-weight: 400;
      white-space: nowrap;
      width: min-content;
    }
  }

  .mobile-menu-item.selected::before {
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 5px;
    height: 5px;
    background-color: ${({ theme }) => theme.softSilverGray};
    border-radius: 50%;
    content: '';
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: block;

    .mobile-menu-container {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;

      height: 100%;

      .mobile-menu-filter {
        margin: 0 20px 20px 20px;
      }

      .mobile-menu-content {
        display: flex;
        gap: 0;
        width: 40%;

        .mobile-menu-item {
          width: 50%;
          .ant-btn {
            display: inline-flex;
            align-items: center;
            flex-direction: column;
            gap: 0;
            width: 100%;

            span {
              height: 24px;
            }
          }

          .text {
            color: ${({ theme }) => theme.neutralGray};
          }
        }

        button {
          height: 60px;
        }

        .mobile-menu-item.selected {
          .text {
            color: ${({ theme }) => theme.bgColorHover};
          }
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    display: block;

    .mobile-menu-container {
      justify-content: space-around;

      .mobile-menu-filter {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }

  @media only screen and (max-width: 356px) {
    .mobile-menu-container {
      .mobile-menu-content {
        .mobile-menu-item {
          .ant-btn {
            padding-right: 5px;
            padding-left: 5px;
          }
        }
      }
    }
  }
`;

export const AdminMobileMenuDrawerHeader = styled('div')`
  .ant-drawer-header {
    padding: 0;
  }
`;

export const StyledMobileNavigationContent = styled('div')`
  .mobile-navigation-block {
    display: flex;
    flex-direction: column;
    gap: 25px;
    .custom-menu-item {
      display: flex;
      gap: 20px;
      color: ${({ theme }) => theme.white};
      span {
        display: inline-flex;
        align-items: center;
      }
      &.active {
        .sider-menu-item-label {
          opacity: 1 !important;
          font-weight: 500;
        }
      }
    }
  }

  .mobile-navigation-block.first {
    padding-bottom: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.white};
    .custom-menu-item {
      .sider-menu-item-label {
        opacity: 0.4;
      }
    }
  }
  .mobile-navigation-block.second {
    padding-top: 20px;
    .custom-menu-item {
      span {
        font-size: 500;
      }
    }
  }
`;
